import React, { useState } from "react";
import { Typography, Box, Alert, Button, TextField } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { resendVerificationEmail } from "../../client/api";

const VerifyEmailPending: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState<string>(searchParams.get("email") || "");
  const [message, setMessage] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const handleResend = async () => {
    if (!email) {
      setError("Enter your email address");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
      const result = await resendVerificationEmail(email);
      setMessage(result.message);
    } catch (err: any) {
      setError(err.message || "Failed to resend verification email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 400, margin: "auto", padding: 4, textAlign: "center" }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Verify your email
      </Typography>
      <Typography sx={{ mb: 3 }}>
        Check your inbox for a verification link. Once verified, you can log in and start using
        the apps.
      </Typography>

      {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <TextField
        fullWidth
        label="Email Address"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        sx={{ mb: 2 }}
        disabled={loading}
      />
      <Button variant="contained" onClick={handleResend} disabled={loading} fullWidth>
        {loading ? "Sending..." : "Resend Verification Email"}
      </Button>
    </Box>
  );
};

export default VerifyEmailPending;
